import slugify from 'slugify';

export const normalizeFileName = (name: string) => `${slugify(name.split('.')[0], {
  replacement: '-',
  remove: /[*+~.()'"!:@]/g,
  lower: true,
})}.${name.split('.').at(-1)}`;
